/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDarkMenuItemSeparator } from "./d-theme-dark-menu-item-separator";

export class DThemeDarkMenuSidedItemSeparator extends DThemeDarkMenuItemSeparator {}
